import { getFetchedDataPayload } from '../../../../../utils/fetched-data/get-fetched-data-payload';
import { temporaryLoyaltyDomainStore } from '../../../temporary-store/store';
import { JourneyGroupType } from '../../../types/journey-group';
import { MemberJourneyListType } from '../../../types/member-journey-list-type';
export const getMemberJourneyGroups = (type) => {
    let state;
    switch (type) {
        case MemberJourneyListType.NextJourney:
        case MemberJourneyListType.Active:
            state = getFetchedDataPayload(temporaryLoyaltyDomainStore.data.memberJourneys.current);
            break;
        case MemberJourneyListType.Recent:
            state = getFetchedDataPayload(temporaryLoyaltyDomainStore.data.memberJourneys.past);
            break;
        default:
            break;
    }
    if (!state)
        return [];
    const { journeyGroups } = state;
    if (type === MemberJourneyListType.NextJourney) {
        const upNextJourneyGroup = journeyGroups.find(group => group.type === JourneyGroupType.UpNext);
        const upNextJourneyId = upNextJourneyGroup === null || upNextJourneyGroup === void 0 ? void 0 : upNextJourneyGroup.journeyIds[0];
        if (!upNextJourneyGroup || !upNextJourneyId)
            return [];
        return [upNextJourneyGroup];
    }
    return journeyGroups;
};
